module.exports = __webpack_public_path__ + "static/designers-a90bd24e7a82aa9353ed6ca9bfae1b52.png";